/** EOL modes per PROJECT_SOURCE_CODE_DESCRIPTION §16.5 (Buffer / Format menu). */
export type EolStyle = "crlf" | "lf" | "cr";

const CRLF = "\r\n";
const LF = "\n";
const CR = "\r";

/** Normalize all line breaks to LF for processing. */
export function normalizeToLf(text: string): string {
  return text.replace(/\r\n/g, LF).replace(/\r/g, LF);
}

/** Convert document text to the target EOL style (content is normalized internally). */
export function convertEol(text: string, target: EolStyle): string {
  const core = normalizeToLf(text);
  if (target === "lf") return core;
  if (target === "crlf") return core.split(LF).join(CRLF);
  return core.split(LF).join(CR);
}

/** Best-effort detect dominant EOL from raw text. */
export function detectEol(text: string): EolStyle {
  if (!text) return "crlf";
  const crlf = (text.match(/\r\n/g) || []).length;
  const lf = (text.match(/(?<!\r)\n/g) || []).length;
  const cr = (text.match(/\r(?!\n)/g) || []).length;
  if (crlf >= lf && crlf >= cr) return "crlf";
  if (lf >= cr) return "lf";
  return "cr";
}
